module.exports = __webpack_public_path__ + "assets/icons/HaulerBidAccepted.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/HaulerBidAccepted.gif
// module id = ./src/styles/icons/emojies/HaulerBidAccepted.gif
// module chunks = 0